import { EventEmitter } from "eventemitter3";

export default class Toggle extends EventEmitter {
  constructor(el) {
    super();
    this.el = el;
    this.el.addEventListener("click", this.onClick.bind(this));
  }

  onClick(e) {
    console.log("click");
    if (!e.target.classList.contains("active")) {
      this.el.classList.toggle("checked");
      const children = this.el.children;
      Array.from(children).forEach((element) => {
        element.classList.toggle("active");
      });

      // check if the input has been checked
      if (this.el.classList.contains("checked")) {
        this.emit("toggle", true);
      } else {
        this.emit("toggle", false);
      }
    }
  }
}
